import { z } from "zod"

const MONTHLY_BILLING_FREQUENCY = 1
const YEARLY_BILLING_FREQUENCY = 12

export const AgreementBillingFrequencySchema = z
    .object({
        billingFrequency: z.number().prefault(YEARLY_BILLING_FREQUENCY),
    })
    .transform(({ billingFrequency }) => {
        if (billingFrequency === MONTHLY_BILLING_FREQUENCY) {
            return "monthly"
        }

        return "yearly"
    })
